export enum KEYBOARD_LAYOUT {
  AZERTY = 'azerty',
  QWERTY = 'qwerty',
  QWERTZ = 'qwertz',
}
